import { Avatar, Box, Grid2 as Grid, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { ReactComponent as LogoSvg } from "../../assets/images/svg/logo/hbscanLogo.svg";

interface HeaderForgotPasswordProps {
  children: ReactNode;
  title: string;
}

const HeaderForgotPassword = ({ children, title }: HeaderForgotPasswordProps) => {
  return (
    <Box
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 2,
        display: 'flex',
        padding: 1
      }}>
      <Grid container alignItems="center">
        <Grid size={{ xs: 9 }}>
          <Typography variant="body1">
            {title}
          </Typography>
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="right">
          <Avatar alt="hbscanLogo" variant="square" sx={{ background: "none", width: "100%" }}><LogoSvg /></Avatar>
        </Grid>
      </Grid>
      {children}
    </Box>
  )
}

export default HeaderForgotPassword
